import { render, staticRenderFns } from "./GrupoDeProdutosTable.vue?vue&type=template&id=1590bed8"
import script from "./GrupoDeProdutosTable.vue?vue&type=script&lang=js"
export * from "./GrupoDeProdutosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports